// extracted by mini-css-extract-plugin
export default {"root":"StudyProgress_root__LyUQA","label":"StudyProgress_label__6WJsu"};